import { Paper, Stack } from "@mui/material";
import { ReactNode } from "react";

type GaiaExpandableMapMarkerBodyProps = {
    children: ReactNode;
};

export function GaiaExpandableMapMarkerBody({ children }: GaiaExpandableMapMarkerBodyProps) {
    return (
        <Stack
            component={Paper}
            sx={{
                gridArea: "content",
                borderTopRightRadius: 0,
                borderTopLeftRadius: 0,
                overflow: "hidden",
            }}
        >
            {children}
        </Stack>
    );
}
